import { TextResourceService } from '../../services/text-resource.service';

export class BaseComponent {
  resources: { [key: string]: string };

  constructor(
    textResourceService: TextResourceService,
    componentName: string) {
    textResourceService.getResources(componentName).subscribe(x => this.resources = x);
  }

  getResource(resourceId: string, capitalize: boolean = false): string {
    if (capitalize) {
      return this.capitalize(this.resources[resourceId]);
    }
    return this.resources[resourceId];
  }

  capitalize(input: string): string {
    return input && input.length > 0 ? `${input[0].toUpperCase()}${input.substring(1)}` : '';
  }
}
